import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function SpinnerIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M3 10a7 7 0 0 1 7-7",
    className: "lb-icon-spinner"
  }));
}

export { SpinnerIcon };
//# sourceMappingURL=Spinner.mjs.map
